const isNotMissing = (value) => value !== void 1;

// noinspection JSUnusedGlobalSymbols
export default isNotMissing;
